<template>
  <div v-if="width && height" class="croppa-box" ref="croppa-box"
    :style="'width: ' + width + 'px; height: ' + (height + 50) + 'px;'">
    <div class="canvas" :style="backgroundEmptyImage" v-if="!edit">
      <img v-if="image" :src="image" :width="width" :height="height" />
      <v-btn v-if="!readOnly" tile color="success" @click="editMode" class="uploader-btn">
        <v-icon> mdi-pencil </v-icon>
      </v-btn>
    </div>
    <div v-else>
      <croppa v-model="croppa" :disabled="readOnly" :show-remove-button="false" :width="width" :height="height"
        :initial-image="image" :placeholder="placeholder_text" placeholder-color="#999999" :placeholder-font-size="14"
        canvas-color="transparent" remove-button-color="black" :show-loading="true" :loading-size="50">
      </croppa>
      <v-btn tile class="uploader-btn" color="success" @click="updateImage">
        <v-icon> mdi-check-bold </v-icon>
      </v-btn>
      <v-btn tile color="secondary" @click="undo" class="uploader-btn">
        <v-icon> mdi-undo </v-icon>
      </v-btn>
      <v-btn tile class="uploader-btn" color="error" @click="clearImage">
        <v-icon> mdi-delete </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "my-img-uploader",
  props: {
    width: {
      type: Number, // not 'number'
      required: false,
      default: 600,
    },
    height: {
      type: Number, // not 'number'
      required: false,
      default: 300,
    },
    readOnly: false,
    value: {
      type: String, // not 'number'
      default: null,
    },
    placeholder: null,
  },
  data() {
    return {
      edit: false,
      image: null,
      undoValue: null,
      convImage: null,
      croppa: {},
      placeholder_text: "drag here",
    };
  },
  methods: {
    reloadCroppa() {
      if (
        this.croppa &&
        this.croppa.refresh &&
        typeof this.croppa.refresh === "function"
      ) {
        this.croppa.refresh();
      }
    },
    clearCroppa() {
      if (
        this.croppa &&
        this.croppa.remove &&
        typeof this.croppa.remove === "function"
      ) {
        this.croppa.remove();
      }
    },
    generateImage() {
      if (
        this.croppa &&
        this.croppa.generateDataUrl &&
        typeof this.croppa.generateDataUrl === "function"
      ) {
        return this.croppa.generateDataUrl("image/png", 0.8);
      } else return null;
    },
    updateImage() {
      if (this.edit) {
        let imgUrl = this.generateImage();
        if (imgUrl) {
          //console.dir("emit update image");
          this.$emit("input", imgUrl);
        } else {
          //console.dir("clear image");
          this.$emit("input", null);
        }
        this.edit = false;
      }
    },
    editMode() {
      this.edit = true;
      this.reloadCroppa();
    },
    clearImage() {
      //console.dir("emit clear image");
      this.clearCroppa();
      //this.edit = false;
    },
    isValidUrl(_string) {
      const matchpattern =
        /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
      return _string.substr(0, 1) == "/" || matchpattern.test(_string);
    },
    setBase64Image(imgUrl) {
      let _ = this;
      var canvas = document.createElement("canvas");
      let bg = new Image();
      bg.src = imgUrl;
      bg.onload = function () {
        canvas.width = bg.width;
        canvas.height = bg.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(bg, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        _.image = dataURL;
        _.$emit("input", dataURL);
      };
    },
    setCroppaImage(newVal) {
      let _ = this;
      if (newVal && _.isValidUrl(newVal)) {
        _.setBase64Image(newVal);
      } else if (newVal) {
        _.image = newVal;
      } else {
        _.image = null;
      }
    },
    undo() {
      let _ = this;
      if (_.undoValue) {
        _.setCroppaImage(_.undoValue);
        _.reloadCroppa();
      }
    },
  },
  computed: {
    backgroundEmptyImage: function () {
      let style =
        "width: " + this.width + "px; height: " + this.height + "px; top: 0px;";
      if (!this.image || this.image === "")
        style +=
          "background-image: url('/img/emptyImage.png'); background-size: contain; background-position: center center;";
      return style;
    },
  },
  mounted() {
    //this.clearCanvas();
    this.edit = false;
    this.image = null;
    this.undoValue = this.value;
    if (this.placeholder) this.placeholder_text = this.placeholder;
    this.setCroppaImage(this.value);
  },
  watch: {
    value: function (newVal, oldVal) {
      //this.clearCanvas();
      this.undoValue = this.value;
      this.setCroppaImage(newVal);
    },
  },
};
</script>

<style>
/* .croppa-container {
  background-color: transparent !important;
  border: 0px !important;
  height: var(height);
  width: var(width);
} */

.croppa-box canvas,
.croppa-box .canvas {
  border-radius: 4px;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: box-shadow;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  border-color: #b3b3b3;
}

.uploader-btn {
  float: right;
  min-width: 50px !important;
  width: 50px;
}

.uploader-btn:not(:first-child) {
  margin: 0px 5px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}
</style>
